function newsSection() {
  const newsSections = document.querySelectorAll(".news");
  // console.log("Found news sections:", newsSections.length);

  newsSections.forEach((section) => {
    const body = document.querySelector("body");
    const openButtons = section.querySelectorAll(".news-item");

    openButtons.forEach((button, index) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        let newsAnchor = button.querySelector("a");
        if (newsAnchor) {
          // console.log("Opening news item:", newsAnchor.href);
          window.open(newsAnchor.href, newsAnchor.target || "_self");
        }
      });
    });
  });

  // Tab handling moved to a delegated module (modules/tabs.js)
}

document.addEventListener("DOMContentLoaded", function () {
  newsSection();
});
